import {
    createSelector
} from 'reselect'

export const tableSettingSelector = createSelector(state => state && state.account && state.account.userTableSetting, tableSettingSelector => tableSettingSelector);
